__turbopack_context__.v({
  "premium": "TeaserFooter-module-scss-module__hiSXeW__premium",
  "regular": "TeaserFooter-module-scss-module__hiSXeW__regular",
  "teaserFooter": "TeaserFooter-module-scss-module__hiSXeW__teaserFooter",
  "timestamp": "TeaserFooter-module-scss-module__hiSXeW__timestamp",
});
